import { initialState } from './initialState';

export default function reducer(state = initialState) {
  return state;
}
